// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"DeleteInviteToMobileAppModal_buttonsContainer__rOPXy"};